<div class="header">
    <i class="fa fa-check header-icon shadow-animation" aria-hidden="true"></i>
</div>
<h5 class="card-title text-success">Pagamento aprovado</h5>
<button class="btn btn-success" (click)="goToHome()">
    Voltar ao menu principal
</button>